import { Camera, MapPin, ScanLine, PackagePlus, ArrowRightLeft, Boxes, PackageOpen, ShoppingCart, Printer, Loader2 } from "lucide-react";

const ICONS = { Camera, MapPin, ScanLine, PackagePlus, ArrowRightLeft, Boxes, PackageOpen, ShoppingCart, Printer };

// Big, glove-friendly floor action button. Honors the tablet blueprint sizing
// (primary h-24/md:h-20, secondary h-16), 64px+ touch target, rounded-xl, and a
// physical press feedback (scale-95 + darken) so a gloved tap is unmistakable.
// transition is scoped to transform+background-color (never `transition-all`).
export function FloorActionButton({ label, icon, tone = "secondary", onClick, testid, busy = false, disabled = false }) {
  const Icon = ICONS[icon] || ScanLine;
  const primary = tone === "primary";
  const base = "w-full rounded-xl font-bold flex items-center justify-center gap-3 select-none " +
    "transition-[transform,background-color] duration-100 active:scale-95 " +
    "disabled:opacity-50 disabled:active:scale-100";
  const size = primary ? "h-24 md:h-20 text-2xl" : "h-16 text-xl";
  const color = primary
    ? "bg-[#B01E28] text-white hover:bg-[#8B1820] active:bg-[#8B1820]"
    : "bg-white text-slate-900 border-2 border-[#E2E8F0] hover:border-slate-300 active:bg-slate-100";
  return (
    <button type="button" data-testid={testid} onClick={onClick} disabled={disabled || busy}
      className={`${base} ${size} ${color}`}>
      {busy ? <Loader2 className={primary ? "w-8 h-8 animate-spin" : "w-7 h-7 animate-spin"} />
            : <Icon className={primary ? "w-8 h-8" : "w-7 h-7"} strokeWidth={2.2} />}
      <span>{label}</span>
    </button>
  );
}
